import React, { Component } from "react";
import { languages } from "../../constants/languages";
import { withTheme } from "@material-ui/core/styles";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

class SportParksContainer extends Component {
  state = {
    open: false,
    anchorEl: null
  };

  selectSportPark = sportParkId => {
    this.props.selectSportPark(sportParkId);
    this.handleClose();
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    let showSportParksMenu = true;
    if (this.props.sportParksByKey["0"]) {
      showSportParksMenu = this.props.sportParks.length > 1;
    } else {
      showSportParksMenu = this.props.sportParks.length > 0;
    }
    return (
      <div style={{ display: "inline-block" }}>
        <div>
          <Menu
            id="menu-days"
            anchorEl={this.state.anchorEl}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left"
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left"
            }}
            getContentAnchorEl={null}
            open={Boolean(this.state.anchorEl)}
            onClose={this.handleClose}
          >
            {/* <MenuItem
              selected={this.props.selectedSportPark === "0"}
              onClick={e => this.selectSportPark("0")}
              style={{ paddingRight: 40 }}
            >
              {(this.props.sportParksByKey["0"] || {}).name ||
                languages.schedule.sportPark + " 1"}
            </MenuItem> */}
            {this.props.sportParks
              .sort((a, b) => {
                if (a.num > b.num) {
                  return 1;
                } else if (a.num < b.num) {
                  return -1;
                }
                if (a.id > b.id) {
                  return 1;
                } else if (a.id < b.id) {
                  return -1;
                } else {
                  return 0;
                }
              })
              .map(sportPark => (
                <MenuItem
                  key={sportPark.id}
                  selected={this.props.selectedSportPark === sportPark.id}
                  onClick={e => this.selectSportPark(sportPark.id)}
                  style={{ paddingRight: 40 }}
                >
                  {sportPark.name}
                </MenuItem>
              ))}
          </Menu>
          {showSportParksMenu && (
            <Button
              size="small"
              variant="outlined"
              color="default"
              onClick={this.handleMenu}
              style={{ whiteSpace: "nowrap" }}
              endIcon={<KeyboardArrowDownIcon />}
            >
              {(this.props.selectedSportPark === "0"
                ? (this.props.sportParksByKey["0"] || {}).name ||
                  languages.schedule.sportPark + " 1"
                : (
                    this.props.sportParksByKey[this.props.selectedSportPark] ||
                    {}
                  ).name
              ).slice(0, 20)}
            </Button>
          )}
        </div>
      </div>
    );
  }
}

export default withTheme(SportParksContainer);
